<template>
  <div @click="showModal()">
    <button
      class="btn bgprimarycolor text-white mr-2"
      data-title="Begin processing"
    >
      <font-awesome-icon class="fa-1x text-white" :icon="['fas', 'check']" />
    </button>

    <b-modal
      ref="processRequestModal"
      size="lg"
      centered
      scrollable
      hide-footer
      @hidden="modalHidden"
      :title="`Process Wallet Request - ${request.projectDetails.name}`"
    >
      <div id="processrequestcontainer">
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.walletid.$error }"
        >
          <label for="walletid" class="form__label">
            From Wallet ID
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            name="walletid"
            id="walletid"
            v-model.trim="$v.walletid.$model"
          />
          <div class="error" v-if="!$v.walletid.required && $v.walletid.$error">
            Wallet Id is required
          </div>
        </div>
        <div class="form-group">
          <label for="cryptooriginalransomdemand"
            >Crypto Original Ransom Demand</label
          >
          <div class="position-relative">
            <input
              type="number"
              class="form-control"
              name="cryptooriginalransomdemand"
              id="cryptooriginalransomdemand"
              :value="request.cryptoOriginalRansomDemand"
              disabled
            />
            <font-awesome-icon
              class="fa-1x infoicon text-info alignicon"
              :icon="['fas', 'copy']"
              @click="
                copyText(
                  request.cryptoOriginalRansomDemand,
                  'processrequestcontainer'
                )
              "
            />
          </div>
        </div>
        <div class="form-group">
          <label for="cryptonegotiatedransomdemand"
            >Crypto Negotiated Ransom Demand</label
          >
          <div class="position-relative">
            <input
              type="number"
              class="form-control"
              name="cryptonegotiatedransomdemand"
              id="cryptonegotiatedransomdemand"
              :value="request.cryptoNegotiatedRansomDemand"
              disabled
            />
            <font-awesome-icon
              class="fa-1x infoicon text-info alignicon"
              :icon="['fas', 'copy']"
              @click="
                copyText(
                  request.cryptoNegotiatedRansomDemand,
                  'processrequestcontainer'
                )
              "
            />
          </div>
        </div>
        <div class="form-group">
          <label for="OriginalRansomDemand">Original Ransom Demand</label>
          <div class="position-relative">
            <input
              type="number"
              class="form-control"
              name="OriginalRansomDemand"
              id="OriginalRansomDemand"
              :value="request.OriginalRansomDemand"
              disabled
            />
            <font-awesome-icon
              class="fa-1x infoicon text-info alignicon"
              :icon="['fas', 'copy']"
              @click="
                copyText(
                  request.OriginalRansomDemand,
                  'processrequestcontainer'
                )
              "
            />
          </div>
        </div>
        <div class="form-group">
          <label for="NegotiatedRansomDemand">Negotiated Ransom Demand</label>
          <div class="position-relative">
            <input
              type="number"
              class="form-control"
              name="NegotiatedRansomDemand"
              id="NegotiatedRansomDemand"
              :value="request.NegotiatedRansomDemand"
              disabled
            />
            <font-awesome-icon
              class="fa-1x infoicon text-info alignicon"
              :icon="['fas', 'copy']"
              @click="
                copyText(
                  request.NegotiatedRansomDemand,
                  'processrequestcontainer'
                )
              "
            />
          </div>
        </div>
        <!-- <div class="form-group" :class="{ 'form-group--error': $v.negotiatedamount.$error }">
          <label for="walletid" class="form__label">Negotiated Amount</label>
          <input
            type="number"
            class="form-control"
            name="negotiatedamount"
            id="negotiatedamount"
            v-model.trim="$v.negotiatedamount.$model"
          />
          <div
            class="error"
            v-if="!$v.negotiatedamount.required && $v.negotiatedamount.$error"
          >Negotiated amount is required</div>
        </div>-->
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.processingdate.$error }"
        >
          <label for="date">
            Processing date
            <span class="text-danger">*</span>
          </label>
          <div>
            <date-picker
              v-model="$v.processingdate.$model"
              type="datetime"
              name="processingdate"
              :show-time-panel="showTimePanel"
              format="DD-MMM-YYYY HH:mm"
              @close="handleOpenChange"
            >
              <template v-slot:footer>
                <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                  {{ showTimePanel ? "Select date" : "Select time" }}
                </button>
              </template>
            </date-picker>
          </div>
          <div
            class="error"
            v-if="!$v.processingdate.required && $v.processingdate.$error"
          >
            Processing date is required
          </div>
        </div>
        <div v-if="showCustomFields">
          <span
            @click="showCustomFields = !showCustomFields"
            class="cfaction text-info"
            >Hide CustomFields</span
          >
          <div
            class="form-group mt-2"
            v-for="field in customfields"
            :key="field.custom_field_id"
          >
            <label for="date">{{ field.custom_field_name }}</label>
            <template v-if="field.type == 'date'">
              <date-picker
                v-model="field.display_value"
                format="DD-MMM-YYYY"
                value-type="format"
                @input="
                  addUpdatedField(field.display_value, field.custom_field_id)
                "
              ></date-picker>
            </template>
            <template v-else>
              <input
                type="text"
                class="form-control"
                v-model="field.display_value"
                @blur="
                  addUpdatedField(field.display_value, field.custom_field_id)
                "
              />
            </template>
          </div>
        </div>
        <div v-else>
          <template v-if="!showCustomFields">
            <span
              @click="showCustomFields = !showCustomFields"
              class="cfaction text-primary"
              >Show CustomFields</span
            >
          </template>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button
          class="btn bgprimarycolor text-white"
          @click="MarkRequestasProcessing"
        >
          Process Request
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import projectService from "../services/projectService";
import walletService from "../services/walletService";
import { EventBus } from "../EventBus";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from "lodash";
export default {
  name: "ProcessRequest",
  props: ["request"],
  components: { DatePicker },
  validations: {
    walletid: { required },
    processingdate: { required },
  },
  data() {
    return {
      walletid: "",
      negotiatedamount: "",
      processingdate: "",
      showTimePanel: false,
      customfields: [],
      original_custom_fields: [],
      showCustomFields: false,
      updated_custom_fields: [],
    };
  },
  methods: {
    showModal() {
      EventBus.$emit("toast", {
        title: "Project Details",
        message: "Fetching Project Details",
        variant: "success",
      });
      let that$ = this;
      projectService
        .getProjectDetails(this.request.projectDetails.projectId, true)
        .then((response) => {
          response.data.data.custom_fields.forEach((f) => {
            if (f.type === "date" && f.display_value !== "") {
              f.display_value = that$.$options.filters.formatDate(
                f.display_value
              );
            }
          });
          this.original_custom_fields = response.data.data.custom_fields;
          this.customfields = _.cloneDeep(response.data.data.custom_fields);

          this.$refs["processRequestModal"].show();
        })
        .catch((err) => {});
    },
    MarkRequestasProcessing(e) {
      console.log(this.updated_custom_fields);
      this.$v.$touch();
      setTimeout(() => {
        if (this.$v.$invalid) {
          this.scrollToLatestError();
        } else {
          e.target.disabled = true;
          this.$bvModal
            .msgBoxConfirm(
              "Please confirm that you want to Process Wallet Request",
              {
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                cancelVariant: "danger",
                okTitle: "Yes",
                cancelTitle: "No",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              }
            )
            .then((value) => {
              if (value) {
                EventBus.$emit("toast", {
                  title: "Details",
                  message: "Updating Wallet Request Details",
                  variant: "success",
                });
                let input = {
                  FromWalletId: this.walletid,
                  NegotiatedAmount: this.negotiatedamount,
                  ProcessedTime: this.processingdate,
                  CustomFields: this.updated_custom_fields,
                };
                let curRequest = {
                  ProjectDetails: {
                    ProjectId: this.request.projectDetails.projectId,
                  },
                  ProcessingDetails: input,
                };
                walletService
                  .processWalletRequest(
                    this.request.paymentRequestId,
                    curRequest
                  )
                  .then((response) => {
                    EventBus.$emit("toast", {
                      title: "Details",
                      message: "Updated Wallet Request Details successfully",
                      variant: "success",
                    });
                    this.$store.commit(
                      "updateWalletRequest",
                      response.data.data.request
                    );
                    this.$refs["processRequestModal"].hide();
                  })
                  .catch((err) => {});
              } else {
                e.target.disabled = false;
              }
            });
        }
        //this.scrollToLatestError();
      }, 50);
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    modalHidden() {
      this.walletid = "";
      this.processingdate = "";
      this.showTimePanel = false;
      this.showCustomFields = false;
      this.$v.$reset();
    },
    addUpdatedField(value, id) {
      const index = this.updated_custom_fields.find(
        (f) => f.custom_field_id === id
      );
      if (index) {
        this.updated_custom_fields.splice(index, 1);
      }
      const field = this.original_custom_fields.find(
        (f) => f.custom_field_id === id
      );
      if (value === null) {
        value = "";
      }

      if (field.display_value !== value) {
        let cField = { ...field };
        cField.display_value = value;
        this.updated_custom_fields.push(cField);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cfaction {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
}
.alignicon {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
        